import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LeaderboardAd, SidebarAd, FooterAd, MultiplexAd, InArticleAd } from './AdSense';
import { useSEO } from '../context/SEOContext';
import SEOMeta from './SEOMeta';
import Footer from './Footer';
// import { CALC_ROUTES } from '../App';
import { CALC_ROUTES } from '../config/Calc_Routes';

const allCalcs = Object.values(CALC_ROUTES).flat();

export default function Layout({ title, desc, color = 'var(--orange)', children }) {
  const loc = useLocation();
  const { getSEO } = useSEO();
  const seo = getSEO(loc.pathname);
  const popular = allCalcs.slice(0, 10);

  return (
    <>
      <SEOMeta path={loc.pathname} />

      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 16px' }}>
        {/* Top Leaderboard Ad */}
        <div style={{ padding: '14px 0 8px' }}>
          <LeaderboardAd />
        </div>

        {/* Breadcrumb + Page Title */}
        <div style={{ marginBottom: '20px' }}>
          {/* Breadcrumb */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px', flexWrap: 'wrap' }}>
            <Link to="/" style={{ fontSize: '12px', color: 'var(--t3)', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--orange)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--t3)'}>🏠 Home</Link>
            <span style={{ fontSize: '12px', color: 'var(--t3)' }}>›</span>
            <span style={{ fontSize: '12px', color: 'var(--t2)', fontWeight: 500 }}>{seo.h1 || title}</span>
          </div>

          {/* H1 with accent bar */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', width: '75%' }}>
            <div style={{ width: '4px', minHeight: '32px', background: color, borderRadius: '4px', marginTop: '2px', flexShrink: 0 }} />
            <div>
              <h1 style={{ fontSize: 'clamp(20px,4vw,28px)', fontWeight: 800, color: 'var(--t1)', letterSpacing: '-0.4px', lineHeight: 1.2, marginBottom: '6px' }}>
                {seo.h1 || title}
              </h1>
              <p style={{ fontSize: '14px', color: 'var(--t2)', lineHeight: 1.6 }}>{seo.intro || desc}</p>
            </div>
          </div>

          {/* Main Layout: Content + Sidebar */}
          <div>
            <div className="calc-with-sidebar">
              {/* Calculator Content */}
              <div>
                {children}

                {/* Post-result ads */}
                <div style={{ marginTop: '16px' }}>
                  <InArticleAd />
                </div>
                <MultiplexAd />
              </div>

              {/* Sidebar (hidden on mobile via media query) */}
              <aside style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <SidebarAd slot="3333333333" />
                <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '14px', padding: '16px' }}>
                  <div style={{ fontSize: '11px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '12px' }}>Popular Calculators</div>
                  {popular.map(item => (
                    <Link key={item.path} to={item.path} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 8px', borderRadius: '8px', textDecoration: 'none', color: 'var(--t2)', fontSize: '13px', fontWeight: 500, transition: 'all 0.15s', marginBottom: '2px' }}
                      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,107,44,0.08)'; e.currentTarget.style.color = 'var(--orange)'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--t2)'; }}>
                      <span style={{ fontSize: '14px' }}>{item.icon}</span>{item.name}
                    </Link>
                  ))}
                </div>
                <SidebarAd slot="4444444444" />
              </aside>
            </div>
          </div>

          <FooterAd />
          <div style={{ height: '16px' }} />
        </div>

      </div>
        <Footer />
    </>
  );
}
